import { i18n } from '@/i18n';
import { showBusinessError } from '@tencent/wphk-components-dialog';
import { DiscountCodeErrMsg } from '@tencent/wphk-components-discount-code/types';
import { useBiReport } from './use-bi-report';

export const useErrorDialog = () => {
  const { biReport } = useBiReport();
  /** 优惠码活动执行错误 */
  const showDiscountCodeExecDialog = (error: any) => {
    const { name } = error;
    const showErrorDialogAndReport = (e) => {
      // 运营活动-迎新奖赏-全城狂赏主页-错误提示曝光
      showBusinessError(e);
      biReport('error_brow', e?.retmsg || i18n('網絡異常，請稍後重試'));
    };
    if (Object.keys(DiscountCodeErrMsg).includes(name)) {
      showErrorDialogAndReport({ retmsg: DiscountCodeErrMsg[name] });
    } else {
      showErrorDialogAndReport(error);
    }
  };
  return {
    showDiscountCodeExecDialog,
  };
};
